export const getContentDeliveryType = (type) => {
  const types = ['cademi', 'astron_members', 'memberkit'];
  if (types.includes(type)) return ['external'];

  return '';
};
